import { Card, Stack, Typography, tokens } from '@cast/design-system';
import pluralize from 'pluralize';

type SummaryCardProps = {
  totalUsage: number;
  instanceCount: number;
};

export const SummaryCard = ({
  totalUsage,
  instanceCount,
}: SummaryCardProps) => {
  const formattedValue = totalUsage.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <Card
      sx={{
        flex: '1 0 0',
        p: 16,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minWidth: 0,
      }}
      data-testid="dbo-summary-card"
    >
      <Stack gap={4}>
        <Typography variant="L10R" color={tokens.theme.fg.structural.secondary}>
          Current month usage
        </Typography>
        <Typography
          color={tokens.theme.fg.structural.primary}
          variant="h3"
          data-testid="dbo-total-usage"
        >
          {formattedValue}
        </Typography>
        <Typography
          variant="P12R"
          color={tokens.theme.fg.structural.secondary}
          data-testid="dbo-instance-count"
        >
          across {instanceCount} {pluralize('database instance', instanceCount)}
        </Typography>
      </Stack>
    </Card>
  );
};
